import { FormControl, InputAdornment, Input } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useEffect, useRef, useState } from 'react'
export interface SearchDebounceProps {
  placeholder: string
  onSearch: (query?: string) => void
}
export function SearchDebounce({ placeholder, onSearch }: SearchDebounceProps) {
  const [searchTerm, setSearchTerm] = useState<string>('')

  const lastSearchTerm = useRef('')
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTerm !== lastSearchTerm.current) {
        lastSearchTerm.current = searchTerm
        onSearch(searchTerm)
      }
    }, 250)
    return () => clearTimeout(delayDebounceFn)
  }, [searchTerm, onSearch])

  return (
    <FormControl variant='outlined' sx={{ display: 'flex' }}>
      <Input
        startAdornment={
          <InputAdornment position='start'>
            <SearchIcon />
          </InputAdornment>
        }
        inputProps={{
          'aria-label': 'leit',
          role: 'searchbox',
          placeholder: placeholder,
        }}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </FormControl>
  )
}
